import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getMockTeacher = id => {
  return {
    id,
    photo: "https://www.thispersondoesnotexist.com/image",
    name: "Nome do Professor",
    email: "email@colegio.com",
    course: "Disciplina"
  };
};

const teacherData = [];
teacherData.push(getMockTeacher(1));
teacherData.push(getMockTeacher(2));
teacherData.push(getMockTeacher(3));
teacherData.push(getMockTeacher(4));

const getTeachers = (searchText = "", course = "") => {
  return api
    .get("Academics/teachers", {
      params: {
        filter: {
          searchText,
          course
        }
      }
    })
    .then(response => response.data);
};

const getSubjetcts = async () => {
  return api.get("ClassDiaryV1/subjects").then(response => response.data);
};

const getSchedule = async (start, end, userId, type) => {
  const res = await api.get(
    `Academics/teacher/schedule${userId ? `/${userId}` : ""}`,
    { params: { start, end, type } }
  );
  return res.data;
};

const getClasses = async () => {
  const res = await api.get("ClassDiaryV1/class", {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const getStudentsForClass = async id => {
  const res = await api.get(`ClassDiaryV1/class/${id}/students`, {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const getScheduleForOccurrence = async id => {
  const res = await api.get(`ClassDiaryV1/class/${id}/occurrences/schedule`, {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const getOccurrenceTypes = async (
  classId,
  idTurmaDisc = undefined,
  codDisc = undefined
) => {
  const res = await api.get(`ClassDiaryV1/occurrences/types`, {
    params: {
      idTurmaDisc,
      classId,
      codDisc
    }
  });
  return res.data;
};

const getOccurrence = async (
  idTurmaDisc,
  occurrenceDate,
  scheduleId,
  weekDay
) => {
  const res = await api.get(`ClassDiaryV1/occurrences`, {
    params: {
      idTurmaDisc,
      occurrenceDate,
      scheduleId,
      weekDay
    }
  });
  return res.data;
};

const saveOccurrence = async occurrenceData => {
  const res = await api.post("ClassDiaryV1/occurrences", {
    externalData: UserStore.getUserExternalInfo(),
    occurrenceData
  });
  return res.data;
};

const occurrenceAttachments = async occurrenceId => {
  const res = await api.get("ClassDiaryV1/occurrencesAttachments", {
    params: {
      occurrenceId
    }
  });
  return res.data;
};

const getOccurrenceStages = async (classId, codPerlet, codDisc) => {
  const res = await api.get("ClassDiaryV1/stages", {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      classId,
      codPerlet,
      codDisc
    }
  });
  return res.data;
};

export default {
  // //////////////////////////
  getTeachers,
  getSubjetcts,
  getSchedule,
  getClasses,
  getStudentsForClass,
  getScheduleForOccurrence,
  getOccurrenceTypes,
  getOccurrence,
  saveOccurrence,
  occurrenceAttachments,
  getOccurrenceStages
};
